const UPDATE_FIRST_ROW_AS_NAMES = 'UPDATE_FIRST_ROW_AS_NAMES';
const UPDATE_FIRST_COLUMN_AS_CATEGORIES = 'UPDATE_FIRST_COLUMN_AS_CATEGORIES';
const UPDATE_REMOVE_OVERLAPPING_CATEGORIES = 'UPDATE_REMOVE_OVERLAPPING_CATEGORIES';
const UPDATE_ALLOW_CATEGORIES_LINE_BREAK = 'UPDATE_ALLOW_CATEGORIES_LINE_BREAK';
const UPDATE_CATEGORIES_ARE_DATES = 'UPDATE_CATEGORIES_ARE_DATES';
const UPDATE_CATEGORIES_ARE_MONTHLY = 'UPDATE_CATEGORIES_ARE_MONTHLY';
const UPDATE_FISCAL_YEARS = 'UPDATE_FISCAL_YEARS';
const UPDATE_IRREGULAR_DATES = 'UPDATE_IRREGULAR_DATES';
const UPDATE_REVERSE_DATE_MONTH = 'UPDATE_REVERSE_DATE_MONTH';
const UPDATE_DATA_SOURCE = 'UPDATE_DATA_SOURCE';
const UPDATE_SPREAD_LINK = 'UPDATE_SPREAD_LINK';
const UPDATE_DATA_NOTES = 'UPDATE_DATA_NOTES';
const UPDATE_DATA_PANEL_TYPE = 'UPDATE_DATA_PANEL_TYPE';
const UPDATE_SHEETS_URL = 'UPDATE_SHEETS_URL';
const UPDATE_SHEETS_LAST_UPDATED = 'UPDATE_SHEETS_LAST_UPDATED';
const UPDATE_SHEETS_ERROR = 'UPDATE_SHEETS_ERROR';
const UPDATE_LOG_SCALE_ALLOWED = 'UPDATE_LOG_SCALE_ALLOWED';
const UPDATE_SHEET_NAME = 'UPDATE_SHEET_NAME';
const UPDATE_SHEET_NAMES = 'UPDATE_SHEET_NAMES';
const UPDATE_FIRST_CELL = 'UPDATE_FIRST_CELL';
const UPDATE_LAST_CELL = 'UPDATE_LAST_CELL';

function updateDataPanelType(payload) {
  return { type: UPDATE_DATA_PANEL_TYPE, payload };
}

function updateFirstRowAsNames(value) {
  return { type: UPDATE_FIRST_ROW_AS_NAMES, payload: value };
}

function updateFirstColumnAsCategories(value) {
  return { type: UPDATE_FIRST_COLUMN_AS_CATEGORIES, payload: value };
}

function updateRemoveOverlappingCategories(value) {
  return { type: UPDATE_REMOVE_OVERLAPPING_CATEGORIES, payload: value };
}

function updateAllowCategoriesLinebreak(value) {
  return { type: UPDATE_ALLOW_CATEGORIES_LINE_BREAK, payload: value };
}

function updateCategoriesAreDates(value) {
  return { type: UPDATE_CATEGORIES_ARE_DATES, payload: value };
}

function updateCategoriesAreMonthly(value) {
  return { type: UPDATE_CATEGORIES_ARE_MONTHLY, payload: value };
}

function updateFiscalYears(value) {
  return { type: UPDATE_FISCAL_YEARS, payload: value };
}

function updateIrregularDates(value) {
  return { type: UPDATE_IRREGULAR_DATES, payload: value };
}

function updateReverseDateMonth(value) {
  return { type: UPDATE_REVERSE_DATE_MONTH, payload: value };
}

function updateDataSource(value) {
  return { type: UPDATE_DATA_SOURCE, payload: value };
}

function updateSpreadLink(value) {
  return { type: UPDATE_SPREAD_LINK, payload: value };
}

function updateDataNotes(value) {
  return { type: UPDATE_DATA_NOTES, payload: value };
}

function updateSheetsUrl(value) {
  return { type: UPDATE_SHEETS_URL, payload: value };
}

function updateSheetsLastUpdated(value) {
  return { type: UPDATE_SHEETS_LAST_UPDATED, payload: value };
}

function updateSheetsError(value) {
  return { type: UPDATE_SHEETS_ERROR, payload: value };
}

function updateSheetName(value) {
  return { type: UPDATE_SHEET_NAME, payload: value };
}

function updateSheetNames(value) {
  return { type: UPDATE_SHEET_NAMES, payload: value };
}

function updateFirstCell(value) {
  return { type: UPDATE_FIRST_CELL, payload: value };
}

function updateLastCell(value) {
  return { type: UPDATE_LAST_CELL, payload: value };
}

function updateLogScaleAllowed(value) {
  return { type: UPDATE_LOG_SCALE_ALLOWED, payload: value };
}

export {
  UPDATE_FIRST_ROW_AS_NAMES,
  UPDATE_FIRST_COLUMN_AS_CATEGORIES,
  UPDATE_REMOVE_OVERLAPPING_CATEGORIES,
  UPDATE_ALLOW_CATEGORIES_LINE_BREAK,
  UPDATE_CATEGORIES_ARE_DATES,
  UPDATE_CATEGORIES_ARE_MONTHLY,
  UPDATE_FISCAL_YEARS,
  UPDATE_IRREGULAR_DATES,
  UPDATE_REVERSE_DATE_MONTH,
  UPDATE_DATA_SOURCE,
  UPDATE_SPREAD_LINK,
  UPDATE_DATA_NOTES,
  UPDATE_DATA_PANEL_TYPE,
  UPDATE_SHEETS_URL,
  UPDATE_SHEETS_LAST_UPDATED,
  UPDATE_SHEETS_ERROR,
  UPDATE_SHEET_NAME,
  UPDATE_SHEET_NAMES,
  UPDATE_FIRST_CELL,
  UPDATE_LAST_CELL,
  UPDATE_LOG_SCALE_ALLOWED,
  updateDataPanelType,
  updateFirstRowAsNames,
  updateFirstColumnAsCategories,
  updateRemoveOverlappingCategories,
  updateAllowCategoriesLinebreak,
  updateCategoriesAreDates,
  updateCategoriesAreMonthly,
  updateFiscalYears,
  updateIrregularDates,
  updateReverseDateMonth,
  updateDataSource,
  updateSpreadLink,
  updateDataNotes,
  updateSheetsUrl,
  updateSheetsLastUpdated,
  updateSheetsError,
  updateSheetName,
  updateSheetNames,
  updateFirstCell,
  updateLastCell,
  updateLogScaleAllowed,
};
